export default __webpack_public_path__ + "static/media/Cauliflower.f7c72b24.jpg";